import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { AuthProvider } from './context/AuthContext';
import { AppContext } from './context/AppContext';
import { UsersProvider } from './context/UsersContext';
import { MessagesProvider } from './context/MessagesContext';

import ProtectedRoute from './auth/ProtectedRoute';
import { HomeScreen, LoginScreen, RegisterScreen } from './screens/';
import { Snackbar, LinearProgress } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { RoomProvider } from './context/RoomContext';
import PageNotFound from './screens/PageNotFound';

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

export default function App() {
  const { snack: _snack, isLoading: _isLoading } = useContext(AppContext);

  const [snack, setSnack] = _snack;
  const [isLoading] = _isLoading;

  return (
    <div>
      <Snackbar
        open={snack.open}
        autoHideDuration={5000}
        onClose={() => setSnack({ open: false, status: '', message: '' })}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Alert
          onClose={() => setSnack({ open: false, status: '', message: '' })}
          severity={snack.status}
        >
          {snack.message}
        </Alert>
      </Snackbar>
      {isLoading && (
        <LinearProgress
          color='secondary'
          style={{ position: 'fixed', left: 0, top: 0, right: 0 }}
        />
      )}
      <AuthProvider>
        <UsersProvider>
          <RoomProvider>
            <MessagesProvider>
              <Router>
                <Switch>
                  <ProtectedRoute exact path='/' component={HomeScreen} />
                  <Route exact path='/login' component={LoginScreen} />
                  <Route exact path='/register' component={RegisterScreen} />
                  <Route exact path='*' component={PageNotFound} />
                </Switch>
              </Router>
            </MessagesProvider>
          </RoomProvider>
        </UsersProvider>
      </AuthProvider>
    </div>
  );
}
